<template>
  <v-form id="pass50" ref="pform" v-model="valid" lazy-validation>
    <v-card class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2 class="v-card--head--title">
            {{ selectedLang.PersonalDataTile12 }}
          </h2>
        </div>
      </v-col>
      <v-card-text>
        <v-row v-if="!user.ab">
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">
                {{ selectedLang.PersonalDataTile13 }}
              </h2>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="kiofCla.includes('TRF')">
          <v-col cols="12">
            <v-checkbox v-model="user.ab" :disabled="pass50" :label="personalDataTile21b"></v-checkbox>
          </v-col>
        </v-row>
        <template v-if="user.ab">
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2">
                  {{ selectedLang.PersonalDataTile21c }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="!protFirm" cols="12">
              <v-text-field v-model="user.firm" :disabled="pass50" :label="selectedLang.PersonalDataTile21d"
                :rules="firmRules"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="user.abfn" :disabled="pass50 || trfdbPreAB" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile19a + '',
                (v) =>
                  /^([^0-9]*)$/.test(v) ||
                  selectedLang.PersonalDataTile19a + '',
                (v) => v.length >= 3 || selectedLang.PersonalDataTile19a + '',
                !similarUSAB || selectedLang.PersonalDataTile21k + '',
              ]" :label="selectedLang.PersonalDataTile21e" :required="user.ab" :hint="hintTextDB"
                :persistent-hint="trfdbPreAB"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="user.abln" :disabled="pass50 || trfdbPreAB" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile23a + '',
                (v) =>
                  /^([^0-9]*)$/.test(v) ||
                  selectedLang.PersonalDataTile23a + '',
                (v) => v.length >= 3 || selectedLang.PersonalDataTile23a + '',
                !similarUSAB || selectedLang.PersonalDataTile21k + '',
              ]" :label="selectedLang.PersonalDataTile21f" :required="user.ab" :hint="hintTextDB"
                :persistent-hint="trfdbPreAB"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="user.abadr" :disabled="pass50" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile27 + '',
                (v) =>
                  /^(?=.*\d).+$/.test(v) ||
                  selectedLang.PersonalDataTile28 + '',
                (v) => v.length >= 3 || selectedLang.PersonalDataTile29 + '',
              ]" :label="selectedLang.PersonalDataTile21g" :required="user.ab"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="user.abpc" :disabled="pass50" :counter="5" :rules="pcRules"
                :label="selectedLang.PersonalDataTile21h" :required="user.ab"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field v-model="user.abcity" :disabled="pass50" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile32 + '',
                (v) =>
                  /^([^0-9]*)$/.test(v) ||
                  selectedLang.PersonalDataTile33 + '',
                (v) => v.length >= 3 || selectedLang.PersonalDataTile34 + '',
              ]" :label="selectedLang.PersonalDataTile21i" :required="user.ab"></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select attach v-model="user.abcountry" :disabled="pass50" :items="itemsState"
                :rules="[(v) => !!v || selectedLang.PersonalDataTile36 + '']" item-text="val"
                :label="selectedLang.PersonalDataTile21j" :required="user.ab"></v-select>
            </v-col>
          </v-row>
          <v-divider style="margin-bottom: 30px"></v-divider>
        </template>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select attach v-model="user.sex" :items="itemsSex" :disabled="pass50" :rules="[
              (v) =>
                !!v || this.$store.state.selectedLang.PersonalDataTile14 + '',
            ]" item-text="val" :label="selectedLang.PersonalDataTile15" required></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-dialog attach v-model="datepickergebu" :close-on-content-click="false" transition="scale-transition"
              offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="computedDateFormatted" :label="selectedLang.PersonalDataTile17" persistent-hint
                  :disabled="pass50" prepend-icon="event" :rules="[(v) => !!v || selectedLang.PersonalDataTile18 + '']"
                  readonly v-on="on" required></v-text-field>
              </template>
              <v-date-picker ref="datepickergebu" v-model="user.gebu" :disabled="pass50" :first-day-of-week="1"
                locale="de-DE" no-title :max="maxGeb" @input="datepickergebu = false"
                @change="user.fgebu = parseDate(user.gebu)"></v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.firstName" :disabled="pass50 || trfdbPreUS" :rules="[
              (v) => !!v || selectedLang.PersonalDataTile19 + '',
              (v) =>
                /^([^0-9]*)$/.test(v) || selectedLang.PersonalDataTile20 + '',
              (v) =>
                /^((?!seat|comfort).)*$/gim.test(v) ||
                selectedLang.PersonalDataTile19 + '',
              (v) => v.length >= 3 || selectedLang.PersonalDataTile21 + '',
              !similarUSAB || selectedLang.PersonalDataTile21l + '',
            ]" :label="selectedLang.PersonalDataTile22" :hint="hintTextDB" :persistent-hint="trfdbPreUS"
              required></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.lastName" :disabled="pass50 || trfdbPreUS" :rules="[
              (v) => !!v || selectedLang.PersonalDataTile23 + '',
              (v) =>
                /^([^0-9]*)$/.test(v) || selectedLang.PersonalDataTile24 + '',
              (v) =>
                /^((?!seat|comfort).)*$/gim.test(v) ||
                selectedLang.PersonalDataTile23 + '',
              (v) => v.length >= 3 || selectedLang.PersonalDataTile25 + '',
              !similarUSAB || selectedLang.PersonalDataTile21l + '',
            ]" :label="selectedLang.PersonalDataTile26" :hint="hintTextDB" :persistent-hint="trfdbPreUS"
              required></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.address" :disabled="pass50" :rules="[
              (v) => !!v || selectedLang.PersonalDataTile27 + '',
              (v) =>
                /^(?=.*\d).+$/.test(v) ||
                selectedLang.PersonalDataTile28 + '',
              (v) => v.length >= 3 || selectedLang.PersonalDataTile29 + '',
            ]" :label="selectedLang.PersonalDataTile30" required></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.postalCode" :disabled="pass50" :counter="5" :rules="pcRules"
              :label="selectedLang.PersonalDataTile31" required></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.city" :disabled="pass50" :rules="[
              (v) => !!v || selectedLang.PersonalDataTile32 + '',
              (v) =>
                /^([^0-9]*)$/.test(v) || selectedLang.PersonalDataTile33 + '',
              (v) => v.length >= 3 || selectedLang.PersonalDataTile34 + '',
            ]" :label="selectedLang.PersonalDataTile35" required></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select attach v-model="uCountry" :disabled="pass50" :items="itemsState" :rules="stateRules" return-object
              item-text="val" :label="selectedLang.PersonalDataTile37" required></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field v-model="user.clientMail" :disabled="pass50" :rules="emailRules"
              :label="selectedLang.PersonalDataTile38" required></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="4">
            <v-text-field
              :disabled="pass50"
              v-model="user.telnum"
              :label="selectedLang.PersonalDataTile39"
            ></v-text-field>
          </v-col> -->
        </v-row>
        <v-col v-if="kiofCla != 'TRFDB'" cols="12">
          <v-checkbox v-model="user.ao" :disabled="pass50" :label="textcb2" @change="checkAO()" required></v-checkbox>
        </v-col>
      </v-card-text>
      <template v-if="user.ao">
        <v-col class="p-0" cols="12">
          <h3 class="hghlght">{{ selectedLang.PersonalDataTile43 }}</h3>
        </v-col>
        <v-card-text>
          <v-row v-if="kiofCla != 'TRFDB'">
            <v-col cols="12" v-if="notAlone">
              <v-alert type="warning" elevation="2">{{ infomationCompanions }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <p v-html="selectedLang.PersonalDataTile50a"></p>
            </v-col>
          </v-row>
          <v-row class="justify-center" v-for="(companion, index) in user.companions" v-bind:key="companion.firstName">
            <v-col cols="12" sm="6">
              <v-select attach v-model="companion.csex" :disabled="pass50" :items="itemsSex"
                :rules="[(v) => !!v || selectedLang.PersonalDataTile44 + '']" item-text="val"
                :label="selectedLang.PersonalDataTile45" required></v-select>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="companion.cfirstName" :disabled="pass50" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile46 + '',
                (v) =>
                  /^((?!seat|comfort).)*$/gim.test(v) ||
                  selectedLang.PersonalDataTile46 + '',
              ]" :label="selectedLang.PersonalDataTile47" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="companion.clastName" :disabled="pass50" :rules="[
                (v) => !!v || selectedLang.PersonalDataTile48 + '',
                (v) =>
                  /^((?!seat|comfort).)*$/gim.test(v) ||
                  selectedLang.PersonalDataTile46 + '',
              ]" :label="selectedLang.PersonalDataTile49" required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <datepicker-year @update="companion.cgebu = $event"></datepicker-year>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn block color="rgb(224, 94, 25)" :disabled="selectedDiv != '50'"
                @click="user.companions.splice(index, 1)">{{ selectedLang.PersonalDataTile52 }}</v-btn>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="12" sm="6">
              <v-btn block color="primary" class="btn-ep-back-to" @click="addCompanion"
                :disabled="selectedDiv != '50'">{{ selectedLang.PersonalDataTile53 }}</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
      <v-card-actions>
        <v-row v-if="selectedDiv == '50'">
          <v-col cols="12">
            <v-btn :disabled="!valid" block class="btn-ep-next-step" @click="check50">{{ selectedLang.PersonalDataTile54
              }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '50' && !noChange">
          <v-col cols="12">
            <v-btn block class="btn-ep-back-to" @click="backToSpecificTile('50')">{{ selectedLang.PersonalDataTile55
              }}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
import DatepickerYear from "./Elements/DatepickerYear.vue";
export default {
  name: "PersonalDataTile",
  components: {
    DatepickerYear,
  },
  data: function () {
    return {
      user: {
        sex: "",
        titel: "",
        gebu: "",
        fgebu: "",
        firstName: "",
        lastName: "",
        address: "",
        postalCode: "",
        city: "",
        state: this.$store.state.selectedLang.PersonalDataTile2,
        clientMail: "",
        telnum: "",
        companions: [],
        ao: false,
        ab: false,
        firm: "",
        abfn: "",
        abln: "",
        abadr: "",
        abpc: "",
        abcity: "",
        abcountry: {
          state: this.$store.state.selectedLang.PersonalDataTile1,
          val: this.$store.state.selectedLang.PersonalDataTile2,
        },
      },
      personalDataTile21b: "",
      personalDataTile40: "",
      textcb1: "",
      textcb2: "",
      infomationCompanions: "",
      datepickergebu: false,
      bookerEqualsTr: false,
      valid: false,
      protFirm: false,
      usFNLN: "",
      hintTextDB: "",
      usABFNLN: "",
      similarUSAB: false,
      trfFrOutDACH: false,
      notAlone: false,
      trfdbPreUS: false,
      trfdbPreAB: false,
      uCountry: {
        state: this.$store.state.selectedLang.PersonalDataTile1,
        val: this.$store.state.selectedLang.PersonalDataTile2,
      },
      pcRules: [
        (v) => !!v || this.$store.state.selectedLang.PersonalDataTile3 + "",
        (v) =>
          /^[0-9]{4,5}$/.test(v) ||
          this.$store.state.selectedLang.PersonalDataTile4 + "",
      ],
      dateRules: [
        (v) => !!v || this.$store.state.selectedLang.PersonalDataTile5 + "",
      ],
      select: null,
      itemsSex: [
        { state: "m", val: this.$store.state.selectedLang.PersonalDataTile6 },
        { state: "f", val: this.$store.state.selectedLang.PersonalDataTile7 },
      ],
      itemsState: [
        { state: "AF", val: "Afghanistan" },
        { state: "AX", val: "Åland Islands" },
        { state: "AL", val: "Albania" },
        { state: "DZ", val: "Algeria" },
        { state: "AS", val: "American Samoa" },
        { state: "AD", val: "Andorra" },
        { state: "AO", val: "Angola" },
        { state: "AI", val: "Anguilla" },
        { state: "AG", val: "Antigua and Barbuda" },
        { state: "AR", val: "Argentina" },
        { state: "AM", val: "Armenia" },
        { state: "AW", val: "Aruba" },
        { state: "AU", val: "Australia" },
        { state: "AT", val: this.$store.state.selectedLang.PersonalDataTileOE },
        { state: "AZ", val: "Azerbaijan" },
        { state: "BH", val: "Bahrain" },
        { state: "BS", val: "Bahamas" },
        { state: "BD", val: "Bangladesh" },
        { state: "BB", val: "Barbados" },
        { state: "BY", val: "Belarus" },
        { state: "BE", val: "Belgium" },
        { state: "BZ", val: "Belize" },
        { state: "BJ", val: "Benin" },
        { state: "BM", val: "Bermuda" },
        { state: "BT", val: "Bhutan" },
        { state: "BO", val: "Bolivia" },
        { state: "BQ", val: "Bonaire, Sint Eustatius and Saba" },
        { state: "BA", val: "Bosnia and Herzegovina" },
        { state: "BW", val: "Botswana" },
        { state: "BV", val: "Bouvet Island" },
        { state: "BR", val: "Brazil" },
        { state: "IO", val: "British Indian Ocean Territory" },
        { state: "BN", val: "Brunei Darussalam" },
        { state: "BG", val: "Bulgaria" },
        { state: "BF", val: "Burkina Faso" },
        { state: "BI", val: "Burundi" },
        { state: "KH", val: "Cambodia" },
        { state: "CM", val: "Cameroon" },
        { state: "CA", val: "Canada" },
        { state: "CV", val: "Cape Verde" },
        { state: "KY", val: "Cayman Islands" },
        { state: "CF", val: "Central African Republic" },
        { state: "TD", val: "Chad" },
        { state: "CL", val: "Chile" },
        { state: "CN", val: "China" },
        { state: "CC", val: "Cocos (Keeling) Islands" },
        { state: "CO", val: "Colombia" },
        { state: "KM", val: "Comoros" },
        { state: "CG", val: "Congo" },
        { state: "CD", val: "Congo (Democratic Republic)" },
        { state: "CK", val: "Cook Islands" },
        { state: "CR", val: "Costa Rica" },
        { state: "CI", val: "Côte d'Ivoire" },
        { state: "HR", val: "Croatia" },
        { state: "CU", val: "Cuba" },
        { state: "CW", val: "Curaçao" },
        { state: "CY", val: "Cyprus" },
        { state: "CZ", val: "Czech Republic" },
        { state: "DK", val: "Denmark" },
        { state: "DJ", val: "Djibouti" },
        { state: "DM", val: "Dominica" },
        { state: "DO", val: "Dominican Republic" },
        { state: "EC", val: "Ecuador" },
        { state: "EG", val: "Egypt" },
        { state: "SV", val: "El Salvador" },
        { state: "GQ", val: "Equatorial Guinea" },
        { state: "ER", val: "Eritrea" },
        { state: "EE", val: "Estonia" },
        { state: "ET", val: "Ethiopia" },
        { state: "FK", val: "Falkland Islands" },
        { state: "FO", val: "Faroe Islands" },
        { state: "FJ", val: "Fiji" },
        { state: "FI", val: "Finland" },
        { state: "FR", val: "France" },
        { state: "GA", val: "Gabon" },
        { state: "GM", val: "Gambia" },
        { state: "GE", val: "Georgia" },
        { state: "DE", val: this.$store.state.selectedLang.PersonalDataTileDE },
        { state: "GH", val: "Ghana" },
        { state: "GI", val: "Gibraltar" },
        { state: "GR", val: "Greece" },
        { state: "GL", val: "Greenland" },
        { state: "GD", val: "Grenada" },
        { state: "GP", val: "Guadeloupe" },
        { state: "GU", val: "Guam" },
        { state: "GT", val: "Guatemala" },
        { state: "GG", val: "Guernsey" },
        { state: "GN", val: "Guinea" },
        { state: "GW", val: "Guinea-Bissau" },
        { state: "GY", val: "Guyana" },
        { state: "HT", val: "Haiti" },
        { state: "HM", val: "Heard Island and McDonald Islands" },
        { state: "VA", val: "Vatican City State" },
        { state: "HN", val: "Honduras" },
        { state: "HK", val: "Hong Kong" },
        { state: "HU", val: "Hungary" },
        { state: "IS", val: "Iceland" },
        { state: "IN", val: "India" },
        { state: "ID", val: "Indonesia" },
        { state: "IR", val: "Iran" },
        { state: "IQ", val: "Iraq" },
        { state: "IE", val: "Ireland" },
        { state: "IM", val: "Isle of Man" },
        { state: "IL", val: "Israel" },
        { state: "IT", val: "Italy" },
        { state: "JM", val: "Jamaica" },
        { state: "JP", val: "Japan" },
        { state: "JE", val: "Jersey" },
        { state: "JO", val: "Jordan" },
        { state: "KZ", val: "Kazakhstan" },
        { state: "KE", val: "Kenya" },
        { state: "KI", val: "Kiribati" },
        { state: "KP", val: "North Korea" },
        { state: "KR", val: "South Korea" },
        { state: "KW", val: "Kuwait" },
        { state: "KG", val: "Kyrgyzstan" },
        { state: "LA", val: "Lao People's Democratic Republic" },
        { state: "LV", val: "Latvia" },
        { state: "LB", val: "Lebanon" },
        { state: "LS", val: "Lesotho" },
        { state: "LR", val: "Liberia" },
        { state: "LY", val: "Libya" },
        { state: "LI", val: "Liechtenstein" },
        { state: "LT", val: "Lithuania" },
        { state: "LU", val: "Luxembourg" },
        { state: "MO", val: "Macao" },
        { state: "MK", val: "Macedonia" },
        { state: "MG", val: "Madagascar" },
        { state: "MW", val: "Malawi" },
        { state: "MY", val: "Malaysia" },
        { state: "MV", val: "Maldives" },
        { state: "ML", val: "Mali" },
        { state: "MT", val: "Malta" },
        { state: "MH", val: "Marshall Islands" },
        { state: "MQ", val: "Martinique" },
        { state: "MR", val: "Mauritania" },
        { state: "MU", val: "Mauritius" },
        { state: "YT", val: "Mayotte" },
        { state: "MX", val: "Mexico" },
        { state: "FM", val: "Micronesia" },
        { state: "MD", val: "Moldova" },
        { state: "MC", val: "Monaco" },
        { state: "MN", val: "Mongolia" },
        { state: "ME", val: "Montenegro" },
        { state: "MS", val: "Montserrat" },
        { state: "MA", val: "Morocco" },
        { state: "MZ", val: "Mozambique" },
        { state: "MM", val: "Myanmar" },
        { state: "NA", val: "Namibia" },
        { state: "NR", val: "Nauru" },
        { state: "NP", val: "Nepal" },
        { state: "NL", val: "Netherlands" },
        { state: "NC", val: "New Caledonia" },
        { state: "NZ", val: "New Zealand" },
        { state: "NI", val: "Nicaragua" },
        { state: "NE", val: "Niger" },
        { state: "NG", val: "Nigeria" },
        { state: "NU", val: "Niue" },
        { state: "NF", val: "Norfolk Island" },
        { state: "MP", val: "Northern Mariana Islands" },
        { state: "NO", val: "Norway" },
        { state: "OM", val: "Oman" },
        { state: "PK", val: "Pakistan" },
        { state: "PW", val: "Palau" },
        { state: "PA", val: "Panama" },
        { state: "PG", val: "Papua New Guinea" },
        { state: "PY", val: "Paraguay" },
        { state: "PE", val: "Peru" },
        { state: "PH", val: "Philippines" },
        { state: "PN", val: "Pitcairn" },
        { state: "PL", val: "Poland" },
        { state: "PT", val: "Portugal" },
        { state: "PR", val: "Puerto Rico" },
        { state: "QA", val: "Qatar" },
        { state: "RE", val: "Réunion" },
        { state: "RO", val: "Romania" },
        { state: "RU", val: "Russia" },
        { state: "RW", val: "Rwanda" },
        { state: "BL", val: "Saint Barthélemy" },
        { state: "SH", val: "Saint Helena, Ascension and Tristan da Cunha" },
        { state: "KN", val: "Saint Kitts and Nevis" },
        { state: "LC", val: "Saint Lucia" },
        { state: "MF", val: "Saint Martin (French part)" },
        { state: "PM", val: "Saint Pierre and Miquelon" },
        { state: "VC", val: "Saint Vincent and the Grenadines" },
        { state: "WS", val: "Samoa" },
        { state: "SM", val: "San Marino" },
        { state: "ST", val: "Sao Tome and Principe" },
        { state: "SA", val: "Saudi Arabia" },
        { state: "SN", val: "Senegal" },
        { state: "RS", val: "Serbia" },
        { state: "SC", val: "Seychelles" },
        { state: "SL", val: "Sierra Leone" },
        { state: "SG", val: "Singapore" },
        { state: "SX", val: "Sint Maarten (Dutch part)" },
        { state: "SK", val: "Slovakia" },
        { state: "SI", val: "Slovenia" },
        { state: "SB", val: "Solomon Islands" },
        { state: "SO", val: "Somalia" },
        { state: "ZA", val: "South Africa" },
        { state: "SS", val: "South Sudan" },
        { state: "ES", val: "Spain" },
        { state: "LK", val: "Sri Lanka" },
        { state: "SD", val: "Sudan" },
        { state: "SR", val: "Suriname" },
        { state: "SZ", val: "Swaziland" },
        { state: "SE", val: "Sweden" },
        { state: "CH", val: this.$store.state.selectedLang.PersonalDataTileSW },
        { state: "SY", val: "Syria" },
        { state: "TW", val: "Taiwan" },
        { state: "TJ", val: "Tajikistan" },
        { state: "TZ", val: "Tanzania" },
        { state: "TH", val: "Thailand" },
        { state: "TL", val: "Timor-Leste" },
        { state: "TG", val: "Togo" },
        { state: "TK", val: "Tokelau" },
        { state: "TO", val: "Tonga" },
        { state: "TT", val: "Trinidad and Tobago" },
        { state: "TN", val: "Tunisia" },
        { state: "TR", val: "Turkey" },
        { state: "TM", val: "Turkmenistan" },
        { state: "TC", val: "Turks and Caicos Islands" },
        { state: "TV", val: "Tuvalu" },
        { state: "UG", val: "Uganda" },
        { state: "UA", val: "Ukraine" },
        { state: "AE", val: "United Arab Emirates" },
        { state: "GB", val: "United Kingdom" },
        { state: "US", val: "United States of America" },
        { state: "UY", val: "Uruguay" },
        { state: "UZ", val: "Uzbekistan" },
        { state: "VU", val: "Vanuatu" },
        { state: "VE", val: "Venezuela" },
        { state: "VN", val: "Vietnam" },
        { state: "VG", val: "British Virgin Islands" },
        { state: "VI", val: "U.S. Virgin Islands" },
        { state: "WF", val: "Wallis and Futuna" },
        { state: "EH", val: "Western Sahara" },
        { state: "YE", val: "Yemen" },
        { state: "ZM", val: "Zambia" },
        { state: "ZW", val: "Zimbabwe" },
      ],
    };
  },
  mounted: function () {
    if (this.kiofCla == "TRF") {
      this.personalDataTile21b = this.selectedLang.PersonalDataTile21b;
      this.personalDataTile40 = this.selectedLang.PersonalDataTile40;
      this.textcb1 = this.selectedLang.PersonalDataTile41a;
      this.textcb2 = this.selectedLang.PersonalDataTile42a;
      let tRFler = this.$store.state.trfTraveler;
      if (tRFler > 1) {
        this.user.ao = true;
        if (this.dataEP.pKnown == "n") {
          this.notAlone = true;
          if (tRFler == 2) {
            this.infomationCompanions = this.selectedLang.PersonalDataTile43a;
          } else {
            this.infomationCompanions = this.formatDBText(
              this.selectedLang.PersonalDataTile43b,
              {
                tRFler: tRFler,
              }
            );
          }
        }
        for (let i = 1; i < tRFler; i++) {
          this.addCompanion();
        }
      }
    } else if (this.kiofCla == "TRFDB") {
      this.personalDataTile21b = this.selectedLang.PersonalDataTile21bDB;
      this.personalDataTile40 = this.selectedLang.PersonalDataTile40DB;
      this.textcb1 = this.selectedLang.PersonalDataTile41aDB;
      this.textcb2 = this.selectedLang.PersonalDataTile42aDB;
      // this.user.firstName = this.preSelectedUData.firstName;
      // this.user.lastName = this.preSelectedUData.lastName;
      // this.trfdbPreUS = true;
      // this.hintTextDB = this.selectedLang.PersonalDataTile23bDB;
      // if (
      //   this.preSelectedUData.abfn != undefined &&
      //   this.preSelectedUData.abln != undefined
      // ) {
      //   this.trfdbPreAB = true;
      //   this.user.ab = true;
      //   this.user.abfn = this.preSelectedUData.abfn;
      //   this.user.abln = this.preSelectedUData.abln;
      // } else {
      //   this.bookerEqualsTr = true;
      // }
    } else {
      this.textcb1 = this.formatDBText(this.selectedLang.PersonalDataTile41, {
        "this.flN": this.flN,
      });
      this.textcb2 = this.formatDBText(this.selectedLang.PersonalDataTile42, {
        "this.flN": this.flN,
      });
    }
    if (this.kiofCla != "TRFDB") {
      if (this.dataFS.airline.icao == "RYR") {
        this.protFirm = true;
      }
    }
  },
  watch: {
    datepickergebu(val) {
      val &&
        setTimeout(() => (this.$refs.datepickergebu.activePicker = "YEAR"));
    },
    uCountry() {
      if (this.kiofCla == "TRF") {
        if (
          !this.dataEP.isGeAr &&
          this.uCountry.state != "DE" &&
          this.uCountry.state != "AT"
        ) {
          this.trfFrOutDACH = true;
          this.user.address = "";
          this.user.city = "";
          this.user.postalCode = "";
        } else {
          this.trfFrOutDACH = false;
        }
      }
    },
    user: {
      deep: true,
      handler() {
        this.usFNLN =
          this.user.firstName.toLowerCase().replace(" ", "") +
          this.user.lastName.toLowerCase().replace(" ", "");
        this.usABFNLN =
          this.user.abfn.toLowerCase().replace(" ", "") +
          this.user.abln.toLowerCase().replace(" ", "");
        if (
          this.usFNLN == this.usABFNLN &&
          this.usFNLN != "" &&
          this.usABFNLN != "" &&
          this.user.ab
        ) {
          this.similarUSAB = true;
        } else {
          this.similarUSAB = false;
        }
      },
    },
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "pass50",
      "maxGeb",
      "emailRules",
      "noChange",
      "selectedLang",
      "flN",
      "kiofCla",
      "trfTraveler",
      "dataFS",
      "dataEP",
      "preSelectedUData",
    ]),
    computedDateFormatted() {
      return this.parseDate(this.user.gebu);
    },
    firmRules() {
      return [
        (v) =>
          v.length >= 6 ||
          v.length == 0 ||
          this.selectedLang.PersonalDataTile21da + "",
        (v) =>
          this.usFNLN != v.replace(" ", "").toLowerCase() ||
          this.selectedLang.PersonalDataTile21db + "",
      ];
    },
    stateRules() {
      return [
        (v) => !!v || this.selectedLang.PersonalDataTile36 + "",
        !this.trfFrOutDACH || this.selectedLang.PersonalDataTile36a,
      ];
    },
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    checkAO() {
      if (!this.user.ao) {
        this.user.companions = [];
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    check50() {
      if (this.$refs.pform.validate()) {
        if (this.uCountry.val != "" || "val" in this.uCountry) {
          this.user.state = this.uCountry.val;
        }

        if (!this.user.ab) {
          this.user.firm = "";
          this.user.abfn = "";
          this.user.abln = "";
          this.user.abadr = "";
          this.user.abpc = "";
          this.user.abcity = "";
        }

        if (this.kiofCla == "TRFDB") {
          this.setSelectedDiv("70");
        } else {
          this.setSelectedDiv("60");
        }

        // if (this.kiofCla.includes("TRF")) {
        //   this.setSelectedDiv("51");
        // } else {
        //   this.setSelectedDiv("60");
        // }

        this.setVar({ pos: "pass50", val: true });
        this.setVar({ pos: "user", val: this.user });
        this.$nextTick(() => {
          this.goToStep({ vm: this, val: this.selectedDiv });
        });
        this.$gtag.event("7b. Personendaten eingegeben", {
          event_category: "Rechner",
          event_label: "7b. Personendaten eingegeben",
        });
      }
    },
    addCompanion: function () {
      this.user.companions.push({
        csex: "",
        cgebu: "",
        cfirstName: "",
        clastName: "",
        ccomputedDateFormatted: "",
      });
      this.$gtag.event("7a. Checkbox Mitreisende angewaehlt", {
        event_category: "Rechner",
        event_label: "7a. Checkbox Mitreisende angewaehlt",
      });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
<style>
label {
  margin-bottom: 0px !important;
}
</style>
